<mat-form-field [formGroup]="parentForm" class="fd-input__container" color="accent">
    <mat-label>{{field?.label}}</mat-label>
    <input matInput [min]='minDate' autocomplete="off" [max]="maxDate" (keyup)="dateMask($event)" class="fd-input__field" maxlength="10" [matDatepicker]="datepickerRef"
        [formControlName]="field?.controlName">
    <mat-datepicker-toggle matSuffix [for]="datepickerRef"></mat-datepicker-toggle>
    <mat-datepicker #datepicker></mat-datepicker>
    <mat-hint class="fd-input__hint">{{field?.hint}}</mat-hint>
    <mat-error *ngIf="hasError">
        <div *ngFor="let errorMessage of errorMessages">{{errorMessage}}</div>
    </mat-error>
</mat-form-field>